import PricebookClauseEditor from "./PricebookClauseEditor";

export default PricebookClauseEditor;



// WEBPACK FOOTER //
// ./src/components/Pricebook/PricebookClauseEditor/index.js